import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/pages/Home'
import About from '@/components/pages/About'
import Contact from '@/components/pages/Contact'
import Documents from '@/components/Documents'
import Enrol from '@/components/pages/Enrol'
import Husky from '@/components/Husky'
import Philosophy from '@/components/pages/Philosophy'
import Gallery from '@/components/pages/Gallery'
import NotFoundComponent from '@/components/pages/NotFoundComponent'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/documents',
      name: 'Documents',
      component: Documents
    },
    {
      path: '/enrol',
      name: 'Enrol',
      component: Enrol
    },
    {
      path: '/husky',
      name: 'Husky',
      component: Husky
    },
    {
      path: '/philosophy',
      name: 'Philosophy',
      component: Philosophy
    },
    {
      path: '/gallery',
      name: 'Gallery',
      component: Gallery
    },
    { path: '*', component: NotFoundComponent }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js